import { Cartesian3 } from "cesium";

export const dataDir = '../../map_data/';

// NOTE: API Port will be 3000 if Docker, otherwise 3001
export const apiPort = '3001';
export const baseUrl = `http://localhost:${apiPort}/`;

export const buildingCols = 'gml_id,damages_prevented,avg_flooding_wp,avg_flooding_wop';
export const roadCols = 'osm_id,avg_flooding_wp,avg_flooding_wop';

export const roadHeight = 1;

export const showOsm = false;
export const showBuildings = true;
export const showRoads = true;

const defaultPosition = Cartesian3.fromDegrees(-74.0707383, 40.7117244, 100);

// Constant defs from ResiumDataSourceWrapper:
// New:
export const floodingWp = 'water_level_above_ground_wp';
export const floodingWop = 'water_level_above_ground_wop';
// Old:
// export const floodingWp = 'flooding_damage_driving_param_wp';
// export const floodingWop = 'flooding_damage_driving_param_wop';

export const damagesPrev = 'Damages Prevented';

export const feet = 'ft';
export const sqft = 'sqft';
export const meters = 'm';
export const usd = '$';
export const T = 'Total';
export const A = 'Average';


export const keyUnitsLookup = {
  'square_feet': sqft,
  'length': feet,
  'foundation_height': feet,
  'ground_elevation': meters,
  'water_level_above_ground_wp': feet,
  'water_level_above_ground_wop': feet,
  'flooding_damage_driving_param_wp': feet,
  'flooding_damage_driving_param_wop': feet,
  'wave_damage_driving_param_wp': feet,
  'wave_damage_driving_param_wop': feet,
  'flood_differential': feet,
  'damages_prevented': usd,
  'total_value_loss_wp': usd,
  'total_value_loss_wop': usd,
  'value_structure': usd,
  'val_contents': usd,
  'content_value_loss_wp': usd,
  'content_value_loss_wop': usd,
  'structure_value_loss_wp': usd,
  'structure_value_loss_wop': usd
}

export const propsOrder = {
  'summary': [
    'ubid', 'Height', floodingWp, floodingWop,
    'total_value_loss_wp', 'total_value_loss_wop', 'damages_prevented', 'nsi_count'
  ],
  'other': [
    'id', 'cshore_consequence_run_id', 'nsi_identifier', 'nsi_count',
    'longitude', 'latitude', 'fips_code',
    'occupancy_type', 'foundation_type', 'is_shallow', 'is_single_point_estimation',
    'square_feet', 'length', 'foundation_height', 'ground_elevation',
    'flood_differential', 'value_structure', 'val_contents', 'left_profile_wop',
    'right_profile_wop', 'left_profile_wp', 'right_profile_wp',
    'distance_along_left_profile', 'distance_along_right_profile',
    'content_fractional_loss_wp', 'content_fractional_loss_wop',
    'structure_fractional_loss_wp', 'structure_fractional_loss_wop',
    'content_value_loss_wp', 'content_value_loss_wop',
    'structure_value_loss_wp', 'structure_value_loss_wop',
    'flooding_damage_driving_param_wp', 'flooding_damage_driving_param_wop',
    'wave_damage_driving_param_wp', 'wave_damage_driving_param_wop',
    'erosion_damage_driving_param_wp', 'erosion_damage_driving_param_wop',
    'erosion_content_fractional_loss_wp', 'erosion_content_fractional_loss_wop',
    'flooding_content_fractional_loss_wp', 'flooding_content_fractional_loss_wop',
    'wave_content_fractional_loss_wp', 'wave_content_fractional_loss_wop',
    'erosion_structure_fractional_loss_wp', 'erosion_structure_fractional_loss_wop',
    'flooding_structure_fractional_loss_wp', 'flooding_structure_fractional_loss_wop',
    'wave_structure_fractional_loss_wp', 'wave_structure_fractional_loss_wop',
  ]
}

export const propsToRound = ['Height', 'area']
export const roadPropsToRound = [
  'flooding_damage_driving_param_wp', 'flooding_damage_driving_param_wop',
  'flood_differential', 'elevation_meter', 'elevation_feet',
  'water_level_above_ground_wp', 'water_level_above_ground_wop']


// GML Properties to remove from the onclick details:
export const propsToRemove = [
  'state', 'grid', 'Latitude', 'Longitude', 'hash', 'bldg:measuredheight',
  'county', 'fp_source', 'height_source', 'cshore_consequence_run_id',
  'longitude', 'latitude', 'is_shallow', 'is_single_point_estimation',
  'left_profile_wop', 'right_profile_wop', 'left_profile_wp', 'right_profile_wp',
  'distance_along_left_profile', 'distance_along_right_profile',
  'content_fractional_loss_wp', 'content_fractional_loss_wop',
  'structure_fractional_loss_wp', 'structure_fractional_loss_wop',
  'erosion_content_fractional_loss_wp', 'erosion_content_fractional_loss_wop',
  'flooding_content_fractional_loss_wp', 'flooding_content_fractional_loss_wop',
  'wave_content_fractional_loss_wp', 'wave_content_fractional_loss_wop',
  'erosion_structure_fractional_loss_wp', 'erosion_structure_fractional_loss_wop',
  'flooding_structure_fractional_loss_wp', 'flooding_structure_fractional_loss_wop',
  'wave_structure_fractional_loss_wp', 'wave_structure_fractional_loss_wop',
  'flood_differential', 'erosion_damage_driving_param_wp',
  'erosion_damage_driving_param_wop'
]

export const roadPropsToRemove = [
  'osm_id_2', 'name_2', 'fips_code', 'id',
  'code', 'fclass', 'ref', 'oneway', 'maxspeed', 'layer', 'bridge', 'tunnel',
  'code_2', 'fclass_2', 'ref_2', 'oneway_2', 'maxspeed_2', 'layer_2', 'bridge_2', 'tunnel_2',
  'cshore_consequence_run_id', 'nsi_identifier',
  'longitude', 'latitude', 'is_shallow', 'is_single_point_estimation',
  'left_profile_wop', 'right_profile_wop', 'left_profile_wp',
  'right_profile_wp', 'distance_along_left_profile', 'distance_along_right_profile',
  'content_fractional_loss_wp', 'content_fractional_loss_wop',
  'structure_fractional_loss_wp', 'structure_fractional_loss_wop',
  'erosion_content_fractional_loss_wp', 'erosion_content_fractional_loss_wop',
  'flooding_content_fractional_loss_wp', 'flooding_content_fractional_loss_wop',
  'wave_content_fractional_loss_wp', 'wave_content_fractional_loss_wop',
  'erosion_structure_fractional_loss_wp', 'erosion_structure_fractional_loss_wop',
  'flooding_structure_fractional_loss_wp', 'flooding_structure_fractional_loss_wop',
  'wave_structure_fractional_loss_wp', 'wave_structure_fractional_loss_wop',
  'occupancy_type', 'foundation_type', 'ground_elevation', 'value_structure', 'val_contents',
  'content_value_loss_wp', 'content_value_loss_wop', 'square_feet', 'length', 'foundation_height',
  'structure_value_loss_wp', 'structure_value_loss_wop', 'total_value_loss_wp', 'total_value_loss_wop',
  'wave_damage_driving_param_wp', 'wave_damage_driving_param_wop', 'erosion_damage_driving_param_wp',
  'erosion_damage_driving_param_wop', 'damages_prevented', '_length', '_inside_x', '_inside_y'
]

export const roadPropsToRename = {
  // The easiest way to change the infobox title is to set our desired field to
  // either 'name' or 'id'. I'm not sure which takes precedence...
  'ubid': 'name (ubid)',
  'Height': `Height - Lidar (${meters})`,
  'height': `height - Open City Model (${meters})`,
  'area': `area (${sqft})`,
  'square_feet': `square_feet (${sqft})`,
  'length': `length (${feet})`,
  'foundation_height': `foundation_height (${A} ${feet})`,
  'ground_elevation': `ground_elevation (${A} ${meters})`,
  'flooding_damage_driving_param_wp': `flooding_damage_driving_param_wp (${A} ${feet})`,
  'flooding_damage_driving_param_wop': `flooding_damage_driving_param_wop (${A} ${feet})`,
  'wave_damage_driving_param_wp': `wave_damage_driving_param_wp (${feet})`,
  'wave_damage_driving_param_wop': `wave_damage_driving_param_wop (${feet})`,
  'flood_differential': `flood_differential (${feet})`,
  'nsi_count': 'NSI Structure Count',
  'total_value_loss_wp': `total_value_loss_wp (${usd})`,
  'total_value_loss_wop': `total_value_loss_wop (${usd})`,
  'value_structure': `value_structure (${usd})`,
  'val_contents': `val_contents (${usd})`,
  'content_value_loss_wp': `content_value_loss_wp (${usd})`,
  'content_value_loss_wop': `content_value_loss_wop (${usd})`,
  'structure_value_loss_wp': `structure_value_loss_wp (${usd})`,
  'structure_value_loss_wop': `structure_value_loss_wop (${usd})`
}

// GML Properties to rename in the onclick details where
// the key is old property name and value is the new property name:
export const propsToRename = {
  // The easiest way to change the infobox title is to set our desired field to
  // either 'name' or 'id'. I'm not sure which takes precedence...
  'ubid': 'name (ubid)',
  'Height': `Height - Lidar (${meters})`,
  'height': `height - Open City Model (${meters})`,
  'area': `area (${sqft})`,
  'square_feet': `square_feet (${sqft})`,
  'length': `length (${feet})`,
  'foundation_height': `foundation_height (${A} ${feet})`,
  'ground_elevation': `ground_elevation (${A} ${meters})`,
  'water_level_above_ground_wp': `water_level_above_ground_wp (${A} ${feet})`,
  'water_level_above_ground_wop': `water_level_above_ground_wop (${A} ${feet})`,
  'flooding_damage_driving_param_wp': `flooding_damage_driving_param_wp (${A} ${feet})`,
  'flooding_damage_driving_param_wop': `flooding_damage_driving_param_wop (${A} ${feet})`,
  'wave_damage_driving_param_wp': `wave_damage_driving_param_wp (${A} ${feet})`,
  'wave_damage_driving_param_wop': `wave_damage_driving_param_wop (${A} ${feet})`,
  'flood_differential': `flood_differential (${A} ${feet})`,
  'damages_prevented': `damages_prevented (${T} ${usd})`,
  'nsi_count': 'NSI Structure Count',
  'total_value_loss_wp': `total_value_loss_wp (${T} ${usd})`,
  'total_value_loss_wop': `total_value_loss_wop (${T} ${usd})`,
  'value_structure': `value_structure (${T} ${usd})`,
  'val_contents': `val_contents (${T} ${usd})`,
  'content_value_loss_wp': `content_value_loss_wp (${T} ${usd})`,
  'content_value_loss_wop': `content_value_loss_wop (${T} ${usd})`,
  'structure_value_loss_wp': `structure_value_loss_wp (${T} ${usd})`,
  'structure_value_loss_wop': `structure_value_loss_wop (${T} ${usd})`
}

export const wpRenamed = `'${propsToRename[floodingWp]}'`;
export const wopRenamed = `'${propsToRename[floodingWop]}'`;
export const damRenamed = `'${propsToRename['damages_prevented']}'`;
export const damwpRenamed = `'${propsToRename['total_value_loss_wp']}'`;
export const damwopRenamed = `'${propsToRename['total_value_loss_wop']}'`;

export const newDamageCols = [
  'id', 'cshore_consequence_run_id', 'nsi_identifier', 'longitude', 'latitude', 'fips_code',
  'occupancy_type', 'foundation_type', 'is_shallow', 'is_single_point_estimation',
  'square_feet', 'length', 'foundation_height', 'ground_elevation',
  'damages_prevented', 'nsi_count', 'total_value_loss_wp', 'total_value_loss_wop',
  'water_level_above_ground_wp', 'water_level_above_ground_wop',
  'flooding_damage_driving_param_wp', 'flooding_damage_driving_param_wop',
  'value_structure', 'val_contents', 'left_profile_wop', 'right_profile_wop', 'left_profile_wp',
  'right_profile_wp', 'distance_along_left_profile', 'distance_along_right_profile',
  'content_fractional_loss_wp', 'content_fractional_loss_wop',
  'structure_fractional_loss_wp', 'structure_fractional_loss_wop',
  'content_value_loss_wp', 'content_value_loss_wop',
  'structure_value_loss_wp', 'structure_value_loss_wop',
  'wave_damage_driving_param_wp', 'wave_damage_driving_param_wop',
  'erosion_damage_driving_param_wp', 'erosion_damage_driving_param_wop',
  'erosion_content_fractional_loss_wp', 'erosion_content_fractional_loss_wop',
  'flooding_content_fractional_loss_wp', 'flooding_content_fractional_loss_wop',
  'wave_content_fractional_loss_wp', 'wave_content_fractional_loss_wop',
  'erosion_structure_fractional_loss_wp', 'erosion_structure_fractional_loss_wop',
  'flooding_structure_fractional_loss_wp', 'flooding_structure_fractional_loss_wop',
  'wave_structure_fractional_loss_wp', 'wave_structure_fractional_loss_wop',
  'flood_differential'
]

export const defaultColor = 'lightgrey'
export const fbpColors = ['blue', 'deepskyblue', 'azure', defaultColor];
export const fbpLegendColors = ['blue', 'deepskyblue', 'azure', defaultColor];
export const dbpColors = ['red', 'orange', 'pink', 'antiquewhite'];

const floodingUnits = 'Water Level Above Ground (ft)';
const damageUnits = 'Damages ($)';

export const consequenceTypeXref = {
  'damages': { 'name': 'damageBreakpoints', 'title': damageUnits },
  'dwop': { 'name': 'damageBreakpoints', 'title': damageUnits },
  'dwp': { 'name': 'damageBreakpoints', 'title': damageUnits },
  'fwop': { 'name': 'floodingBreakpoints', 'title': floodingUnits },
  'fwp': { 'name': 'floodingBreakpoints', 'title': floodingUnits }
};

export const locationConfigs = {
  absecon: {
    name: 'Absecon Island',
    nameShort: 'Absecon',
    nameLong: 'Absecon Island, NJ',
    // new:
    assetId: 1618121,
    // old:
    // assetId: 1290054,
    // assetId: 1333963,
    assetIdRoads: 1618123,
    buildingPushpins: `${dataDir}/absecon/building-pushpins.geojson`,
    buildingStructures: `${dataDir}/absecon/absecon-structures-4326.geojson`,
    zoom_center: [-74.45526678312494, 39.35178697258851],
    zoom_degree: 14,
    damageCols: newDamageCols,
    x: -74.459716,
    y: 39.339728,
    z: 20000,
    xMin: -74.4953390732526,
    xMax: -74.3961411865264,
    yMin: 39.3176250909078,
    yMax: 39.3702033514305,
    roadFloodingBreakpoints: {
      lowest: 0,
      neutral: 5,
      high: 10
    },
    floodingBreakpoints: {
      lowest: 0,
      neutral: 5,
      high: 10
    },
    damageBreakpoints: {
      lowest: 1000000,
      low: 2000000,
      neutral: 3000000,
      high: 4000000
    },
    structureCounts: {
      fwp: [1919, 0, 0, 0, 0, 1],
      fwop: [1907, 1, 5, 2, 5, 0],
      dwp: [1862, 56, 2, 0, 0],
      dwop: [1640, 264, 10, 2, 4],
      damages: [1640, 280, 0, 0, 0]
    }
  },
  martin: {
    name: 'Martin County',
    nameShort: 'Martin',
    nameLong: 'Martin County, Florida',
    assetId: 1618124,
    assetIdRoads: 1618125,
    buildingPushpins: `${dataDir}/martin/martin-pushpins.geojson`,
    buildingStructures: `${dataDir}/martin/martin-structures.geojson`,
    zoom_center: [-80.18594389462943, 27.233894063182575],
    zoom_degree: 14,
    damageCols: newDamageCols,
    x: -80.183217,
    y: 27.227196,
    z: 20000,
    xMin: -80.2017609048725,
    xMax: -80.1650486488489,
    yMin: 27.2129095778204,
    yMax: 27.2630454913683,
    roadFloodingBreakpoints: {
      lowest: 0,
      neutral: 5,
      high: 10
    },
    floodingBreakpoints: {
      lowest: 0,
      neutral: 5,
      high: 10
    },
    damageBreakpoints: {
      lowest: 1000000,
      low: 2000000,
      neutral: 3000000,
      high: 4000000
    },
    structureCounts: {
      fwp: [67, 0, 0, 0, 0, 0],
      fwop: [67, 0, 0, 0, 0, 0],
      dwp: [62, 5, 0, 0, 0],
      dwop: [60, 5, 2, 0, 0],
      damages: [61, 5, 1, 0, 0]
    }
  }
}
